import React from 'react';

import Location from '../../../../helpers/uiComponents/Location';
import AccordianTitle from '../../../../helpers/uiComponents/Accordian';

export class StoreLocations extends React.Component {
	render() {
		const currentClient = this.props.currentClient;
		const locations = currentClient.locations.filter( loc => { return loc.type === "store" && loc.clientCode === currentClient.clientCode; });
		const franchisees = currentClient.locations.filter( loc => { return loc.type === "store" && loc.clientCode !== currentClient.clientCode; });
		return (
			<div className="input-group">
				<AccordianTitle title={"Store Locations"} />
				<div className="accordian-body">
					<em>If this client has Franchisees assigned (Franchise Section), the store locations of those franchisees will be automatically added to the Franshisor website.</em>
					<em>Please maintain franchisee store location information within the franchisees.</em>
					{(franchisees.length > 0) && (
						<React.Fragment>
							<h4> Franchisee Locations</h4>
							<table>
								<thead>
									<tr>
										<th>clientCode</th>
										<th>Name</th>
										<th>City</th>
										<th>State</th>
									</tr>
								</thead>
								<tbody>
									{franchisees.map(location =>
										<tr key={location.id}>
											<td>{location.clientCode}</td>
											<td>{location.name}</td>
											<td>{location.city}</td>
											<td>{location.state}</td>
										</tr>
									)}
								</tbody>
							</table>
						</React.Fragment>
					)}

					<h4>{currentClient.name} Locations</h4>
					<Location
						locations={locations}
						clientCode={currentClient.clientCode}
						type={"store"}
						container={"store-location"}
					/>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/component_client/components/ClientProfile/ProfileComponents/StoreLocations.js